var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dictionary-simple-table',{attrs:{"dictionary_link":"/product-code-types","title":"Lista typów kodu","numeral_text":['typ kodu', 'typy kodu', 'typów kodu'],"columns_title":['name']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }